import React from 'react';

interface TabPanelProps extends React.HTMLAttributes<HTMLElement> {
  tabValue: number | string;
  value: number | string;
}

export const TabPanel = React.memo(function TabPanel({
  children,
  className,
  tabValue,
  value,
}: TabPanelProps): JSX.Element | null {
  return tabValue === value ? <div className={className}>{children}</div> : null;
});
